// extracted by mini-css-extract-plugin
module.exports = {"navTab":"nav-list_navTab__3z6kv","active":"nav-list_active__lI7it"};